<template>
  <footer class="w-full bg-neutral-700 px-4 md:px-11 py-10">
    <div class="max-w-3xl mx-auto w-full flex flex-col gap-8">
      <div class="flex flex-col md:flex-row gap-8 md:justify-between">
        <div class="flex flex-col gap-1">
          <div class="font-extrabold">{{ t('footer.addressTitle') }}</div>
          <div class="text-neutral-300">ZNIPP GmbH</div>
          <div class="text-neutral-300">Underschwändlistrasse 10</div>
          <div class="text-neutral-300">6048 Horw</div>
          <div class="text-neutral-300">{{ t('footer.country') }}</div>
        </div>

        <div class="flex flex-col gap-1">
          <div class="font-extrabold">{{ t('footer.contactTitle') }}</div>
          <a href="mailto:hello@mysoundz.ch">hello@mysoundz.ch</a>
          <a href="tel:+41325101385">+41 32 510 13 85</a>
          <RouterLink :to="{ name: 'contact' }">{{ t('footer.contactForm') }}</RouterLink>
        </div>

        <div class="flex flex-col gap-1">
          <div class="font-extrabold">{{ t('footer.linksTitle') }}</div>
          <RouterLink :to="{ name: 'imprint' }">{{ t('footer.imprint') }}</RouterLink>
          <RouterLink :to="{ name: 'privacy' }">{{ t('footer.privacy') }}</RouterLink>
          <RouterLink :to="{ name: 'login' }">{{ t('header.login') }}</RouterLink>
        </div>
      </div>

      <div class="flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
        <SocialLinks :size="20" />
        <p class="text-neutral-300 mt-0 mb-0">&copy; {{ year }} MySoundz Network</p>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import SocialLinks from '@/components/SocialLinks.vue'

const { t } = useI18n()

const year = new Date().getFullYear()
</script>
